import React, { useState, useEffect } from "react";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import i18n from "../i18n";




export const FormElements = ({ field, question_id, questions, value, readonly }) => {
  const allowPlateDash = String(process.env.REACT_APP_ALLOW_PLATE_DASH || "false").toLowerCase() === "true";
  const plateSanitizeRegex = allowPlateDash ? /[^A-Z0-9ŠĐČĆŽ-]/g : /[^A-Z0-9ŠĐČĆŽ]/g;

  const sanitizeRegistrationValue = (inputValue) => {
    if (!inputValue) {
      return "";
    }

    return inputValue
      .toUpperCase()
      .replace(plateSanitizeRegex, "");
  };



  let filtered = questions.filter(a => a.id == question_id);

  if (filtered[0]) {
    switch (filtered[0].field_type) {
      case 1:
        return (<InputText {...field} />); break;
      case 2:
        return (<div className="p-inputgroup">
          <InputText
            {...field}
            onChange={(e) => {
              const sanitizedValue = sanitizeRegistrationValue(e.target.value);
              field.onChange({
                ...e,
                target: {
                  ...e.target,
                  name: field.name,
                  value: sanitizedValue,
                },
              });
            }}
            onPaste={(e) => {
              e.preventDefault();
              const pastedText = e.clipboardData.getData("text");
              const sanitizedValue = sanitizeRegistrationValue(pastedText);
              field.onChange({
                target: {
                  name: field.name,
                  value: sanitizedValue,
                },
              });
            }}
          />
        </div>);  break;
      case 33:
        return (<div className="p-inputgroup">
          {value}
          <InputSwitch checked={value} {...field} />
        </div>); break;
      case 3:
        let chelist = [
          {
            label: i18n.t("yes"),
            value: "1",
          },
          {
            label: i18n.t("no"),
            value: "0",
          },
        ];
        return (
          <Dropdown
            {...field}
            style={{ width: "40px" }}
            options={chelist}
          />
        );       
        break;
      case 4:
        // broj telefona
        return (<InputText {...field} keyfilter={/^[0-9]*$/} />); break;
      case 5:
        return (<InputText {...field} />); break;
      case 6:
        return (<InputText {...field} />); break;
      case 7:
        return (<InputText {...field} keyfilter="num" />); break;
      default: return (<InputText {...field} />); break;
    }

  } else {
    return (<InputText {...field} />);
  }

};
